import { createSelector } from 'reselect'

export const createSession = createSelector(
  (state: any) => state.session,
  sessionData => sessionData,
)
